{
  "main": {
    "title": "Ispezione delle superfici",
    "subtitle": "Modulo n. 1 - Rapporto di ispezione delle superfici per le aree di movimento degli aeromobili",
    "titleOddan": "Ispezione per oggi completata",
    "contentOddan": "L'ispezione della pista per oggi è già stata effettuata. Vuoi inviarne un'altra?",
    "nazaj": "Indietro"
  },
  "nav": {
    "vnos": "inserimento",
    "zapisi": "registri"
  },
  "obrazecA": {
    "title": "A. AEROPORTO",
    "description": "Informazioni di base sull'aeroporto",
    "formLabel1": "Codice ICAO (4 lettere)",
    "formLabel2": "Nome dell'aeroporto"
  },
  "obrazecB": {
    "title": "B. DATA E ORA DELL'ISPEZIONE (ORA LOCALE)",
    "description": "Data e ora dell'ispezione delle superfici",
    "formLabel1": "Data (DD.MM.YYYY)",
    "formLabel2": "Ora (HHMM)"
  },
  "obrazecC": {
    "title": "C. DESIGNATORE DELLA PISTA",
    "description": "Identificazione della pista",
    "formLabel1": "Designatore pista (XX-XX)"
  },
  "obrazec1": {
    "title": "1. CONDIZIONE DELLA SUPERFICIE",
    "description": "Condizione delle superfici nelle varie zone dell'aeroporto",
    "surfaceLabel": "Superficie",
    "vse": "tutte",
    "ploscadi": "Apron"
  },
  "obrazec3": {
    "title": "3. CARENZE",
    "description": "Controllo delle carenze sulle superfici",
    "surfaceLabel": "Carenza",
    "vse": "tutte",
    "ploscadi": "Apron"
  },
  "obrazec4": {
    "title": "4. OSTACOLI",
    "description": "Controllo degli ostacoli sulle superfici",
    "surfaceLabel": "Ostacolo",
    "vse": "tutte",
    "ploscadi": "Apron"
  },
  "obrazec5": {
    "title": "5. PRESENZA DI UCCELLI",
    "description": "Controllo della presenza di uccelli sulle superfici",
    "surfaceLabel": "Uccello",
    "gridLabel": "Presenza di uccelli",
    "vse": "tutte",
    "ploscadi": "Apron"
  },
  "obrazec6": {
    "title": "6. NOTE",
    "description": "Note e commenti aggiuntivi",
    "surfaceLabel": "Nota",
    "gridLabel": "Note",
    "vse": "tutte",
    "ploscadi": "Apron"
  },
  "obrazec7": {
    "title": "7. ISPEZIONE",
    "description": "Ispezione delle piazzole di atterraggio per elicotteri",
    "surfaceLabel": "Ispezione",
    "gridLabel": "Piazzole di atterraggio per elicotteri",
    "vse": "tutte",
    "vseOK": "tutte ok",
    "ploscadi": "Apron"
  },
  "conditions": {
    "dryClean": "a) asciutto e pulito",
    "damp": "b) umido",
    "wet": "c) bagnato",
    "puddles": "d) pozzanghere",
    "waterLayer": "e) strato d'acqua"
  },
  "deficiency": {
    "surfaceDamage": "danni alle superfici pavimentate",
    "foreignObjects": "oggetti estranei",
    "unevenness": "irregolarità oltre i limiti consentiti",
    "horizontalMarkings": "segnaletica orizzontale",
    "verticalMarkings": "segnaletica verticale",
    "safetyStrip": "fascia di sicurezza e pista di base",
    "other": "altro"
  },
  "zapisi": {
    "title": "Registri delle ispezioni delle superfici",
    "description": "Panoramica di tutti i moduli inviati per l'ispezione delle superfici",
    "ni": "Nessun registro",
    "niDescription": "Nessuna ispezione delle superfici è stata ancora inviata. Usa la scheda 'Inserimento' per compilare il modulo.",
    "info": "Se non vedi il documento, usa il pulsante di download",
    "posiljam": "Invio..."
  },
  "buttons": {
    "pocisti": "Cancella modulo",
    "poslji": "Invia modulo",
    "prenesi": "Scarica documento"
  },
  "labels": {
    "datum": "Dato"
  },
  "obvestila": {
    "zapisPrihodnost": "Il record ha una data impostata nel futuro, CORREGGI la data selezionata!",
    "zapisCasPrihodnost": "Una o più voci hanno un'ora impostata nel futuro, controlla gli orari!",
    "zapisCasNapaka": "Gli orari dei record non sono corretti! Controlla di nuovo gli orari!",
    "zapisDodan": "Record aggiunto con successo",
    "napakaPristanka": "L'orario di atterraggio non può essere precedente all'orario di decollo!",
    "zapisPobrisan": "Record eliminato con successo",
    "napakaPrazenPristanek": "Errore di inserimento, l'orario di atterraggio non può essere vuoto",
    "posodobitevUspesna": "Aggiornamento riuscito",
    "napakaPosodabljanja": "Errore durante l'aggiornamento dei dati.",
    "napakaBranja": "Errore durante la lettura dei dati.",
    "napakaIzbrisa": "Errore durante l'eliminazione dei dati.",
    "vprasanjeIzbris": "Sei sicuro di voler eliminare il record?",
    "napakaVnosaPolja": "Errore di inserimento, controlla se tutti i campi sono compilati!",
    "napakaVnosa": "Errore nell'inserimento dei dati",
    "napakaValidacije": "Errore nella validazione dei campi! Controlla se tutti i campi sono compilati!",
    "letZakljucen": "Volo completato con successo.",
    "letNiZakljucen": "Errore nel completamento del volo."
  }
}